import { baseApi } from 'services/baseApi';
import { AppConstants } from 'constants/index';
import { SystemConversion as SystemConversionType } from 'app/systemConversion/types';

export const systemConversionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSystemConversionsResource: builder.query<SystemConversionType[], void>({
      query: () => {
        const { ReportingAdmin, SystemConversion, Resource } = AppConstants.api;
        return {
          url: [ReportingAdmin, SystemConversion, Resource],
        };
      },
    }),
  }),
});

export const { useGetSystemConversionsResourceQuery } = systemConversionApi;
